const AuthenticatorAppIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path
      d='M15.75 5.25002C16.5456 5.25002 17.3087 5.56609 17.8713 6.1287C18.4339 6.69131 18.75 7.45437 18.75 8.25002M21.75 8.25002C21.7501 9.12513 21.5588 9.98968 21.1895 10.783C20.8202 11.5764 20.2818 12.2794 19.6121 12.8427C18.9424 13.406 18.1575 13.816 17.3126 14.0439C16.4677 14.2718 15.5831 14.3121 14.721 14.162C14.158 14.065 13.562 14.188 13.158 14.592L10.5 17.25H8.25V19.5H6V21.75H2.25V18.932C2.25 18.335 2.487 17.762 2.909 17.341L9.408 10.842C9.812 10.438 9.935 9.84202 9.838 9.27902C9.6962 8.46019 9.72604 7.62082 9.92563 6.81413C10.1252 6.00743 10.4902 5.25099 10.9975 4.59275C11.5047 3.9345 12.1432 3.38881 12.8724 2.99026C13.6016 2.5917 14.4057 2.34897 15.2336 2.27745C16.0616 2.20593 16.8953 2.30718 17.6821 2.57478C18.4688 2.84238 19.1914 3.2705 19.8041 3.832C20.4167 4.3935 20.906 5.07615 21.241 5.83667C21.5759 6.59719 21.7493 7.419 21.75 8.25002Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default AuthenticatorAppIcon
